import { gql } from '@apollo/client';
import { IncidentFieldsFragment } from './fragments';

export default gql`
  mutation IncidentCreate($input: IncidentCreateInput!) {
    incidentCreate(input: $input) {
      entity {
        ...IncidentFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${IncidentFieldsFragment}
`;
